import SearchCriteriaCls from './SearchCriteriaCls'

const SearchCriteriaClsObj = new SearchCriteriaCls()

export default SearchCriteriaClsObj.GetSearchCriteria()
